export default __webpack_public_path__ + "static/media/2.6d1cbcc2.jpg";